module.exports = __webpack_public_path__ + "static/card-blog4-1379fb067477d3719a0036b6762ea48b.png";